export default __webpack_public_path__ + "static/media/icon-add-blue.8e2d0d35.svg";